export const uInt32MaxVal = 0xffffffff;

/**
 * Use crypto.getRandomValues to replace Math.random to get a number between 0 to 1(exclusive)
 * https://stackoverflow.com/a/62792582
 *
 * please also modify getRandomNumber in packages/core-utilities/src/generateGuid.ts
 * when you modify this function. Scenario: https://microsoft.visualstudio.com/OS/_workitems/edit/41542542
 */
export const getRandomNumber = (): number => {
    const crypto = window.crypto || window.msCrypto;
    if (crypto) {
        const randomBuffer = new Uint32Array(1);
        // Result is at most 2^32 because argument is an uint32 array
        const result = crypto.getRandomValues(randomBuffer);
        // We devide result by uInt32MaxVal + 1 to make sure the return value is between 0 to 1(exclusive)
        return (result[0] / (uInt32MaxVal + 1));
    }
    // Fallback if window.crypto is not supported by the browser
    // tslint:disable-next-line: insecure-random
    return Math.random();
};

/**
 * Generate GUID part.
 *
 * please also modify guidPart in packages/core-utilities/src/generateGuid.ts
 * when you modify this function. Scenario: https://microsoft.visualstudio.com/OS/_workitems/edit/41542542
 */
export const guidPart = (): string => {
    // Use crypto.randomBytes() or window.crypto.getRandomValues() does not work in IE 11
    // This is to reach parity with Angular
    const randomNumber = getRandomNumber();
    // 65536 is 1000 in hexadecimal so we do substring(1) to get 4 characters
    // tslint:disable-next-line: no-bitwise
    return ((1 + randomNumber) * 65536 | 0).toString(16).substring(1);
};

/**
 * Generates a random GUID string.
 *
 * please also modify generateGuid in packages/core-utilities/src/generateGuid.ts
 * when you modify this function. Scenario: https://microsoft.visualstudio.com/OS/_workitems/edit/41542542
 */
export const generateGuid = (): string => {
    return `${guidPart()}${guidPart()}-${guidPart()}-${guidPart()}-${guidPart()}-${guidPart()}${guidPart()}${guidPart()}`;
};
